export default __webpack_public_path__ + "static/media/TroubleAhead_Still_2.d1ac3e02.jpg";